import React from 'react';
import { Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

export const PopupTrustPaymentBlock = ({ children }) => (
  <div className={cx('wrapper')}>
    <div className={cx('icon-back')}><div className={cx('icon')} /></div>
    <Text size="size5-r-s" tagType="p">{children}</Text>
  </div>
);
